import request from '../utils/request';

export async function getShopTransfer(shop, state, type, start, end, skip, take, info) {
  return await request(`platbiz/transordershop?shop=${shop}&state=${state}&type=${type}&start=${start}&end=${end}&skip=${skip}&take=${take}&info=${info}`, 'get');
}